/**
 * Управляет селекторами баннера
 * @param {*} selector
 */
export const handleBannerSelect = (selector) => {
    if (selector.hasClass("active")) {
        selector.find(".get-course__pop-select").slideUp();
        selector.removeClass("active");
    } else {
        // Скрываем остальные открыте селекторы
        $(".get-course__select").each(function () {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).find(".get-course__pop-select").slideUp();
            }
        });

        selector.addClass("active");
        selector.find(".get-course__pop-select").slideDown();
    }
};

/**
 * Инициализирует скрипты для баннера
 */
export const initBanner = () => {
    // Клик по опции в селекте
    $(".get-course__pop-options").on("click", function () {
        $(this).parent().slideUp();
        $(".get-course__pop-options").removeClass("hide");
        const value = $(this).text().trim();
        $(this).parent().parent().find(".get-course__input").val(value);
    });

    $(document).mouseup(function (e) {
        var div = $(".get-course__select");
        if (!div.is(e.target) && div.has(e.target).length === 0) {
            $(".get-course__input")
                .parent()
                .find(".get-course__pop-select")
                .slideUp();
            $(".get-course__pop-options").removeClass("hide");
            div.removeClass("active");
        }
    });

    let initBannerOptions = function () {
        $(".get-course__pop-options")
            .off()
            .click(function () {
                let textInput = $(this)
                    .parent()
                    .parent()
                    .find(".get-course__input");

                let id = $(this).data("id");
                let entity = textInput.attr("name");
                let selectedText = $(this).text();

                let targetEntity = entity === "country" ? "program" : "country";

                let thisContainer = $(this).closest(".get-course__select");
                let otherContainer = $(this)
                    .closest(".get-course__form")
                    .find(".get-course__select")
                    .not(thisContainer);

                $.get(
                    "/api/filter/search",
                    {
                        params: { [entity]: id },
                        entity: targetEntity,
                    },
                    function (data) {
                        console.log("search");
                        let selectContainer = otherContainer.find(
                            ".get-course__pop-select"
                        );
                        selectContainer.html("");

                        for (let item of data) {
                            let newDiv = $("<div>");
                            newDiv.addClass("get-course__pop-options");
                            newDiv.data("id", item.id);
                            newDiv.text(item.name.trim());
                            selectContainer.append(newDiv);
                        }

                        initBannerOptions();
                    }
                );

                $(this).parent().slideUp();
                $(".get-course__pop-options").removeClass("hide");

                textInput.val(selectedText.trim());
                $(`[name="banner-search__${entity}"]`).val(id);
            });
    };

    initBannerOptions();

    let courseInput = $(".get-course__input");

    courseInput.focusout(function () {
        const el = $(this);
        setTimeout(function () {
            el.parent()
                .find(".get-course__pop-select")
                .stop(true, true)
                .slideUp();
            $(".get-course__pop-options").removeClass("hide");
        }, 100);
    });

    // allow fetch countries in page start
    let isCountryFetchAllowed = true;

    courseInput.keyup(function () {
        const element = $(this);
        var value = element.val().toLowerCase().trim();

        const isCountrySelect =
            $(this).attr("name").toLowerCase() === "country";

        console.log(isCountrySelect);

        // if countries fetch is allowed
        if (isCountryFetchAllowed && isCountrySelect) {
            // fetch countries, skip already used countries (offset=13)
            $.get(
                "/api/catalog/data?entity=country&link=1&offset=13",
                function (data) {
                    const popupSelect = element
                        .parent()
                        .find(".get-course__pop-select");
                    data.forEach((item) => {
                        // create new div of each countries items
                        let newDiv = $("<div>");
                        // newDiv.attr('data-id', item.id);
                        newDiv.data("id", item.id);
                        newDiv.addClass("get-course__pop-options");
                        newDiv.text(item.name.trim());
                        // and append to search popup
                        popupSelect.append(newDiv);
                    });

                    // reinit banner options
                    initBannerOptions();
                }
            );

            // deny country fetching if we get all couuntries once
            isCountryFetchAllowed = false;
        }

        element
            .closest(".get-course__select")
            .find(".get-course__pop-options")
            .each(function (i, elem) {
                const text = $(elem).text().toLowerCase().trim();
                const regex = new RegExp("" + value);
                if (regex.test(text)) {
                    $(elem).addClass("show");
                    $(elem).removeClass("hide");
                } else {
                    $(elem).addClass("hide");
                    $(elem).removeClass("show");
                }
            });
    });
};
